import React, { useState, useEffect, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Layout, Button, Menu } from "antd";
import { InfoCircleOutlined, LogoutOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { getBalanceAsync } from "../../redux/journalSlice";
import { removeAgentState } from "../../redux/loadStorage";
import { getProductAsync } from "../../redux/features/feature-slice";
import packageJson from "../../../package.json";
import { saveFeaturesState } from "../../redux/featuresStorage";

const { Sider } = Layout;
const { SubMenu } = Menu;

export function Sidebar({ features }) {

  const dispatch = useDispatch();
  const location = useLocation();
  const [isBalance, setIsBalance] = useState(false);
  const { currentAgent } = useSelector((state) => state.auth);
  const history = useHistory();
  const { balance, isFetchingBalance } = useSelector((state) => state.journal);

  const handleSolde = useCallback(() => {
    const data = {
      country: currentAgent?.country,
      pincode: "",
      token: currentAgent?.access_token,
    };
    dispatch(getBalanceAsync(data));
  }, [dispatch, currentAgent]);

  useEffect(() => {
    dispatch(
      getProductAsync({
        application: "Web Agent",
        type: "product",
        country: currentAgent?.country,
      })
    );
  }, [dispatch, currentAgent]);

  const handlelogout = async () => {
    removeAgentState();
    history.push("/login");
  };


  const orderPriority = ["Woyofal", "SEN'EAU", "Senelec", "OOLU"];
  const sortCategories = (categories) => {
    return [...categories].sort((a, b) => {
      const indexA = orderPriority.indexOf(a.title);
      const indexB = orderPriority.indexOf(b.title);

      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    });
  };
  const sortedData = features.map((section) => {
    if (section.title === "Factures & Recharges") {
      return {
        ...section,
        categories: sortCategories(section.categories),
      };
    }
    return section;
  });

  // console.log("sortedData ===>", sortedData);



  return (
    <>
      <Sider
        className="sidebar"
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(broken) => { console.log(broken) }}
        onCollapse={(collapsed, type) => { console.log(collapsed, type); }}>
        <div className="avatar">
          <div
            className="flag"
            style={{
              backgroundImage: `url("./assets/img/flag-${currentAgent?.country}.png")`,
            }}
          />
          <div>
            <p>
              <strong>{currentAgent?.username}</strong>
            </p>
            <span>{currentAgent?.phone}</span>
          </div>
        </div>
        <div className="solde">
          {isBalance ? (
            <Button
              className="btn-secondary"
              onClick={() => {
                handleSolde();
                setIsBalance(true);
              }}
            >
              {isFetchingBalance ? "Chargement..." : `Solde: ${balance.toLocaleString('fr-FR')} F CFA`}{" "}
            </Button>
          ) : (
            <Button
              className="btn-secondary"
              onClick={() => {
                handleSolde();
                setIsBalance(true);
              }}
            >
              {isFetchingBalance ? "Chargement..." : "Voir mon solde"}{" "}
            </Button>
          )}
        </div>
        <Menu
          selectedKeys={[location.pathname]}
          defaultSelectedKeys={["/dashboard"]}
          mode="inline">
          <Menu.Item
            key={"/home"}
            icon={
              <img src="/assets/img/icon-home.png" alt="icon" className="icon" />
            }
          >
            <NavLink to={"/home"} className="menu-link">
              <span>Accueil</span>
            </NavLink>
          </Menu.Item>
          <>
            {
              sortedData?.map((item) => {
                return (
                  <>
                    {
                      item.categories.length === 0 && (
                        <Menu.Item key={`/${item.title}_${item.route}`} disabled={!item.isActive} icon={<img src={`/assets/img/${item.icon}`} alt="icon" className="icon" />}>
                          <NavLink to={item.route} className="menu-link">
                            {item.title}
                          </NavLink>
                        </Menu.Item>
                      )
                    }

                    {item?.categories?.length > 0 && (
                      <>
                        <SubMenu
                          title={item.title}
                          disabled={!item.isActive}
                          key={"SubMenu_" + item.title}
                          icon={<img src={`/assets/img/${item.icon}`} alt="icon" className="icon" />}>
                          {item.categories?.map((childItem) => {
                            return (
                              <>
                                <Menu.Item
                                  disabled={!childItem.isActive}
                                  key={"/" + childItem.route}
                                  icon={<img src={`/assets/img/${childItem.icon}`} alt="icon" className="icon" />}>
                                  <NavLink to={childItem.route} className="menu-link" onClick={() => saveFeaturesState(childItem)}>
                                    {childItem.title}
                                  </NavLink>
                                </Menu.Item>
                              </>
                            );
                          })}
                        </SubMenu>
                      </>
                    )}
                  </>
                );
              })}
          </>

          <Menu.Item key={"/transaction"} icon={<img src="/assets/img/icon-transaction.png" alt="icon" className="icon" />}>
            <NavLink to={"/transaction"} className="menu-link">
              <span>Historique</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item
            key={"/pincode-reset"}
            icon={
              <img
                src="/assets/img/icon-pincode-reset.png"
                alt="icon"
                className="icon"
              />
            }
          >
            <NavLink to={"/pincode-reset"} className="menu-link">
              <span>Modifier code pin</span>
            </NavLink>
          </Menu.Item>

          <li
            className="ant-menu-item default-item"
            onClick={() => handlelogout()}
          >
            <LogoutOutlined />{" "}
            <span className="ant-menu-title-content">DECONNEXION</span>
          </li>
          <li className="ant-menu-item default-item">
            <InfoCircleOutlined />{" "}
            <span className="ant-menu-title-content">
              {" "}
              Version: {packageJson.version}{" "}
            </span>
          </li>
        </Menu>
      </Sider>
    </>
  );
}